const messages = {
  'page.signup-codes.title': 'Organisation joining codes',
  'page.signup-codes.table.header.code': 'Code',
  'page.signup-codes.table.header.org': 'Organisation',
  'page.signup-codes.table.header.date': 'Start date',
  'page.signup-codes.table.header.times-used': 'Times used',
  'page.signup-codes.table.header.status': 'Status',
  'page.signup-codes.table.header.status.active': 'Active',
  'page.signup-codes.table.header.status.deactivated': 'Deactivated',
  'page.signup-codes.table.btn.view-more.mobile': 'View',
  'page.signup-codes.table.btn.view-more.desktop': 'View more',
  'page.signup-codes.error': "There's been an error loading the signup codes. Please try again.",
  'page.signup-codes.btn.create': 'Create code',
  'page.signup-codes.btn.reload': 'Reload data',
}

const createCodeModal = {
  'page.signup-codes.modal.create-code.title': 'Create a new code',
  'page.signup-codes.modal.create-code.input.organisation-id.label': 'Enter organisation ID',
  'page.signup-codes.modal.create-code.btn.label': 'Create code',
  'page.signup-codes.modal.create-code.btn.loading': 'Creating code...',
}

const deactivateCodeModal = {
  'page.signup-codes.modal.deactivate-code.title': 'Are you sure?',
  'page.signup-codes.modal.deactivate-code.description':
    'By deactivating this code, anyone attempting to sign up with this it will  no longer be able to do so.',
  'page.signup-codes.modal.deactivate-code.btn.continue.label': 'Yes, continue',
  'page.signup-codes.modal.deactivate-code.btn.cancel.label': 'No, go back',
}

const createCodeNotifications = {
  'notifications.signup-codes.create.success.title': 'Code successfully created',
  'notifications.signup-codes.create.success.description':
    'The code {code} has been assigned to {organisation}.',
  'notifications.signup-codes.create.failure.title': 'Code not created!',
  'notifications.signup-codes.create.failure.description':
    'There has been a problem creating this joining code. Please try again',
}

export default {
  ...messages,
  ...createCodeModal,
  ...deactivateCodeModal,
  ...createCodeNotifications,
}
